import styled from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
export const Content = styled.div `
  margin-top: 0;
  margin-bottom: 0;
  width: 100%;
  text-align: center;
  
  
  svg {
    width: 2.8rem;
    height: 2.8rem;
    fill: var(--primary-darker);
  }
  
  .btn.btn--primary {
    margin-top: 1rem !important;
  }

  @media screen and (max-width: ${MediaSizes.XS_MAX}px){
    .close {
      right: -0.5rem;
      top: 0.2rem;
    }
  }
`;
export const Title = styled.span `
  font: var(--heading-three-font);
  color: var(--primary-darker);
  text-align: center;
`;
export const DiscountList = styled.ul `
  display: flex;
  list-style: none;
  flex-direction: column;
  gap: 1.8rem;
  padding: 0;
`;
export const DiscountItem = styled.li `
  padding: 0;  
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;
export const DiscountIcon = styled.svg `
  width: 2.8rem;
  height: 2.8rem;
  fill: var(--primary-darker);
`;
export const DiscountTitle = styled.span `
  font: var(--heading-four-font);
  color: var(--primary-darker);
  margin-top: 1rem;
  margin-bottom: 0.5rem;
`;
export const DiscountCopy = styled.span `
  font: var(--paragraph-font);
  color: var(--text);
`;
export default {
    Content,
};
